import { createFileRoute } from "@tanstack/react-router";

import { SessionInjectionSettingsPanel } from "../components/settings/SessionInjectionSettings";

function SettingsInstructionsRoute() {
  return <SessionInjectionSettingsPanel />;
}

export const Route = createFileRoute("/settings/instructions")({
  component: SettingsInstructionsRoute,
});
